module.exports = __webpack_public_path__ + "static/media/job-2.ab2c7866.png";